import React from 'react';
import { GraduationCap } from 'lucide-react';
import { Section, Card } from '../hospital/shared/primitives';
import { LinkRow, IntroRow } from '../shared/ListRows';

const ACCENT = '#334155';

const BCMResourcesTrainees = () => (
  <div className="space-y-6">
    <Card>
      <IntroRow icon={GraduationCap} accent={ACCENT}>
        College-wide resources for residents and fellows. Department policies and contacts are on the BCM Anesthesiology page.
      </IntroRow>
    </Card>

    <Section title="Programs">
      <Card>
        <LinkRow title="Resident as Teacher" subtitle="GME curriculum in teaching skills" href="https://www.bcm.edu/education/graduate-medical-education/resident-as-teacher" />
        <LinkRow title="BCM Libraries" subtitle="Databases, journals and study space" href="https://www.bcm.edu/libraries" />
      </Card>
    </Section>

    <Section title="Benefits and policies">
      <Card>
        <LinkRow title="Benefits" subtitle="Health insurance, retirement and more" href="https://www.bcm.edu/education/graduate-medical-education/current-residents-and-fellows/benefits" />
        <LinkRow title="GME policies and procedures" subtitle="Duty hours, leave, moonlighting and the rest" href="https://www.bcm.edu/education/graduate-medical-education/policies-and-procedures" />
      </Card>
    </Section>

    <Section title="Wellness">
      <Card>
        <LinkRow title="Employee Assistance Program" subtitle="Free, confidential counseling, 24 hours a day" href="tel:1-800-364-6352" />
      </Card>
    </Section>
  </div>
);

export default BCMResourcesTrainees;
